module.exports = __webpack_public_path__ + "static/media/icon@2x.e9ca37b3.png";